import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { BreadcrumbsComponent, StatusTagComponent } from '@shared/components';
import { Breadcrumb } from '@shared/models';

@Component({
  selector: 'app-details-page-header',
  templateUrl: './details-page-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, RktIconComponent, StatusTagComponent, BreadcrumbsComponent],
})
export class DetailsPageHeaderComponent {
  @Input() pageReturnURL!: string;

  @Input() title!: string;

  @Input() status?: string;

  @Input() breadcrumbs?: Breadcrumb[];
}
